import useTextBlock from '@components/text-block/text-block.hook';
import classNames from 'classnames';
import type { Theme } from 'constants/colors';
import type { ReactElement, ReactNode } from 'react';
import React from 'react';
import type { TextBlockSize } from 'types/components/text-block';
import type { Layout } from 'types/layout';
import { validateString } from 'utils/validate-string';

import styles from './text-block.module.scss';

interface Props {
  readonly className?: string | undefined;
  readonly eyebrow?: ReactNode | undefined;
  readonly heading: ReactNode;
  readonly subHeading?: ReactNode | undefined;
  readonly description?: ReactNode | undefined;
  readonly layout?: Layout | undefined;
  readonly callsToAction?: ReactNode | undefined;
  readonly size?: TextBlockSize | undefined;
  readonly theme?: Theme | undefined;
}

const headingClass = validateString(styles.heading);
const eyebrowClass = validateString(styles.eyebrow);
const subHeadingClass = validateString(styles.subHeading);
const textBodyClass = validateString(styles.textBody);
const ctaContainerClass = validateString(styles.ctaContainer);

function TextBlock({
  className,
  description,
  heading,
  layout = 'left',
  subHeading,
  eyebrow,
  callsToAction,
  size = 'medium',
  theme,
}: Props): ReactElement {
  const { displayCta, rootClass } = useTextBlock({
    callsToAction,
    size,
    layout,
  });

  return (
    <div className={classNames(rootClass, theme, className)}>
      {typeof eyebrow !== 'undefined' && (
        <div className={eyebrowClass}>{eyebrow}</div>
      )}
      <div className={classNames(headingClass)}>{heading}</div>
      {typeof subHeading !== 'undefined' && (
        <div className={subHeadingClass}>{subHeading}</div>
      )}
      {typeof description !== 'undefined' && description !== null && (
        <div className={textBodyClass}>{description}</div>
      )}

      {displayCta === true && (
        <div className={ctaContainerClass}>{callsToAction}</div>
      )}
    </div>
  );
}

export default TextBlock;
